import React, { useState, createRef } from "react";
import { Link, useLocation } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { toAbsoluteUrl } from "../../../_metronic";
import HeaderDropdownToggle from "../content/CustomDropdowns/HeaderDropdownToggle";
import { Constants } from "../../utils/Constants";
import { Col, Modal } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import { getDataTable, create } from "../../crud/solicitacao.crud";
import AdminAutoComplete from "../../components/AdminAutoComplete";
import BetterDataTable from "../../components/BetterDataTable";
import Swal from "sweetalert2";
import { listaFormatoImagens, textoExclusao } from "../../utils/Utils";
import { Column } from "primereact/column";
import moment from "moment";
import { useSelector } from "react-redux";

export default function UserProfile({ showHi, showAvatar }) {
    const [openModal, setOpenModal] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [anexos, setAnexos] = useState([]);
    const [solicitacao, setSolicitacao] = useState("");
    const [usuario, setUsuario] = useState("");
    const [novaSolicitacao, setNovaSolicitacao] = useState(false);
    const [visualizarSolicitacao, setVisualizarSolicitacao] = useState(null);

    const { user } = useSelector(({ auth }) => auth);

    const { pathname } = useLocation();

    const inputRef = createRef();

    const moreOptions = (data) => {
        return (
            <button type="button" onClick={() => setVisualizarSolicitacao(data)} className="btn btn-primary btn-table-action">
                <i className="fas fa-eye"></i>
            </button>
        );
    };

    const esconderBotaoSolicitacoes = () => {
        const urls = ["/relatorio/relatorio01", "/relatorio/relatorio02", "/relatorio/relatorio03", "/relatorio/relatorio04", "/relatorio/relatorio05", "/relatorio/relatorio06", "/admin", "/group", "/notificacao", "/solicitacao", "/envio", "/conta-bancaria", "/tag", "/produto", "/fornecedor", "/representante", "/financeiro-evento", "/master-associado-pagamento", "/fatura", "/evento", "/terceiro", "/associado", "/master-associado", "/contrato"];

        const esconder_url = !urls.some((url) => pathname === url);

        const regex = [/^\/solicitacao\/show\/\d+$/, /^\/solicitacao\/edit\/\d+$/, /^\/notificacao\/show\/\d+$/, /^\/notificacao\/edit\/\d+$/, /^\/envio\/show\/\d+$/, /^\/envio\/edit\/\d+$/, /^\/admin\/edit\/\d+$/, /^\/group\/edit\/\d+$/];
        return esconder_url && !regex.some((regex) => regex.test(pathname));
    };

    const returnType = (anexo_aux) => {
        const name_array = anexo_aux?.id ? anexo_aux.anexo.fil_name.split(".") : anexo_aux.img.name.split(".");
        const type = name_array[name_array.length - 1];

        return type;
    };

    const adicionar = () => {
        if (solicitacao.trim() === "" || !usuario) {
            return Swal.fire("Ops!", "Preencha todos os campos obrigatórios para adicionar.", "error");
        }

        if (anexos.find((anexo) => anexo?.nome?.trim() === "")) {
            return Swal.fire("Ops!", "Coloque nome em todos os anexos.", "error");
        }

        const form_data = new FormData();

        form_data.append("sol_descricao", solicitacao);
        form_data.append("sol_id_admin_receptor", usuario?.id);
        form_data.append("sol_origem", `${Constants.url_admin}${window.location.pathname}`);

        if (anexos) {
            anexos.forEach((anexo, key) => {
                form_data.append(`anexos[${key}][nome]`, anexo.nome);
                form_data.append(`anexos[${key}][img]`, anexo.img);
            });
        }

        setSubmitted(true);

        create(form_data)
            .then((res) => {
                if (res.data?.errors) {
                    return Swal.fire("Ops!", res.data?.errors[0] ?? "Parece que houve um problema. Por favor, entre em contato com o suporte.", "error");
                }

                Swal.fire("Sucesso!", "Solicitação criada com sucesso.", "success");

                setSolicitacao("");
                setUsuario("");
                setAnexos([]);
                setNovaSolicitacao(false);
            })
            .catch(() => Swal.fire("Ops!", "Parece que houve um problema. Por favor, entre em contato com o suporte.", "error"))
            .finally(() => setSubmitted(false));
    };

    const removerAnexo = (index) => {
        Swal.fire(textoExclusao).then((result) => {
            if (result.value) {
                const array_anexos = anexos.filter((_, key) => key !== index);

                setAnexos(array_anexos);
            }
        });
    };

    const adicionarAnexos = (files) => {
        if (anexos.length + files.length > 10) {
            return Swal.fire("Ops!", "Número máximo de anexos é 10.", "info");
        }

        const anexo_aux = [...anexos];

        Object.keys(files).forEach((key) => {
            anexo_aux.push({
                img: files[key],
                nome: "",
            });
        });

        setAnexos(anexo_aux);

        inputRef.current.value = "";
    };

    return (
        <>
            <Dropdown className="kt-header__topbar-item kt-header__topbar-item--user" drop="down" alignRight>
                <Dropdown.Toggle as={HeaderDropdownToggle} id="dropdown-toggle-user-profile">
                    <div className="kt-header__topbar-user">
                        {showHi && <span className="kt-header__topbar-welcome kt-hidden-mobile">Olá,</span>}

                        {showHi && <span className="kt-header__topbar-username kt-hidden-mobile">{user.adm_nome}</span>}

                        {showAvatar && (
                            <div
                                style={{
                                    width: "34px",
                                    height: "34px",
                                    backgroundImage: `url(${user.foto ? user.foto : "/images/no-profile.png"})`,
                                    backgroundSize: "cover",
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "50% 50%",
                                    borderRadius: "50%",
                                }}
                            />
                        )}
                    </div>
                </Dropdown.Toggle>

                {esconderBotaoSolicitacoes() && (
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <button type="button" className="btn btn-info btn-bold botao-solicitacoes" style={{ height: "40px", display: "flex", alignItems: "center", justifyContent: "center" }} onClick={() => setOpenModal(true)}>
                            <i className="fas fa-plus"></i>
                            <p className="mb-0">Solicitações internas</p>
                        </button>
                    </div>
                )}

                <Dropdown.Menu className="dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
                    <div className="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x" style={{ backgroundImage: `url(${toAbsoluteUrl("/media/bg/bg-5.jpg")})` }}>
                        {showAvatar && (
                            <div className="kt-user-card__avatar">
                                <span className="kt-badge kt-badge--lg kt-badge--rounded kt-badge--bold kt-font-success">
                                    <img alt="" src={user.foto ? user.foto : "/images/no-profile.png"} />
                                </span>
                            </div>
                        )}

                        <div className="kt-user-card__name">{user.adm_nome}</div>
                    </div>

                    <div className="kt-notification">
                        <a href={`${Constants.url_paginas_externas}/associado/meus-contratos`} className="kt-notification__item">
                            <div className="kt-notification__item-icon">
                                <i className="flaticon2-right-arrow" />
                            </div>

                            <div className="kt-notification__item-details">
                                <div className="kt-notification__item-title kt-font-bold">Associado</div>
                                <div className="kt-notification__item-time">Acesso para o associado.</div>
                            </div>
                        </a>

                        <a href={`${Constants.url}/planilha/Modelo.xlsx`} className="kt-notification__item">
                            <div className="kt-notification__item-icon">
                                <i className="flaticon2-file-1" />
                            </div>
                            <div className="kt-notification__item-details">
                                <div className="kt-notification__item-title kt-font-bold">Planilha</div>
                                <div className="kt-notification__item-time">Modelo para importação de veículos.</div>
                            </div>
                        </a>

                        <div className="kt-notification__custom">
                            <Link to="/logout" className="btn btn-primary btn-bold">
                                Sair
                            </Link>
                        </div>
                    </div>
                </Dropdown.Menu>
            </Dropdown>

            <Modal show={visualizarSolicitacao} size={"xl"} centered onHide={() => setVisualizarSolicitacao(null)} style={{ padding: "0 !important" }}>
                <Modal.Header closeButton>
                    <Modal.Title className="tt-14 color-gray-100 semibold">Visualizar solicitação</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="row">
                        <div className="col-sm-12">
                            <TextField label="Usuário" margin="normal" variant="outlined" value={visualizarSolicitacao?.receptor?.adm_nome} disabled />
                        </div>

                        <div className="col-sm-12">
                            <TextField multiline minRows={3} label="Solicitação" margin="normal" variant="outlined" value={visualizarSolicitacao?.sol_descricao} disabled />
                        </div>

                        {visualizarSolicitacao?.anexos?.length > 0 ? (
                            <>
                                {visualizarSolicitacao.anexos.map((anexo, key) => {
                                    return (
                                        <div key={key} className="col-sm-4">
                                            <div className="imagemUploaderMargem">
                                                <a target={"_blank"} rel="noopener noreferrer" href={anexo.anexo.url}>
                                                    <div className="imagemUploaderBackground" style={{ backgroundImage: `url("${anexo.anexo.url}")` }}>
                                                        {!listaFormatoImagens.includes(returnType(anexo)) && <i className="fas fa-file" aria-hidden="true" style={{ fontSize: "180px" }}></i>}
                                                    </div>
                                                </a>
                                            </div>

                                            <TextField style={{ marginTop: "0px" }} label="Nome do anexo" margin="normal" variant="outlined" value={`${anexo?.sao_nome}`} disabled />
                                        </div>
                                    );
                                })}
                            </>
                        ) : (
                            <Col sm={12} style={{ marginTop: "15px" }}>
                                <center>
                                    <h5>Sem anexos.</h5>
                                </center>
                            </Col>
                        )}
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                        <button type="button" className="btn btn-danger btn-bold" onClick={() => setVisualizarSolicitacao(null)}>
                            <i className={`margin-icon ${submitted ? "fas fa-sync fa-spin" : "fa fa-window-close"}`}></i>Fechar
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal show={openModal} size={"xl"} centered onHide={() => setOpenModal(false)} style={{ padding: "0 !important" }}>
                <Modal.Header closeButton>
                    <Modal.Title className="tt-14 color-gray-100 semibold">Solicitações internas</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="row">
                        {!novaSolicitacao && (
                            <div className="col-sm-3" style={{ marginTop: "16px" }}>
                                <button type="button" onClick={() => setNovaSolicitacao(!novaSolicitacao)} className="btn btn-primary btn-with-input btn-bold">
                                    <i className={`margin-icon ${submitted ? "fas fa-sync fa-spin" : "fa fa-check-square"}`}></i>Nova solicitação
                                </button>
                            </div>
                        )}

                        {novaSolicitacao && (
                            <>
                                <div className="col-sm-12">
                                    <AdminAutoComplete setValue={(e) => setUsuario(e)} value={usuario} label="Usuário" />
                                </div>

                                <div className="col-sm-12">
                                    <TextField multiline minRows={3} label="Solicitação" margin="normal" variant="outlined" onChange={(e) => setSolicitacao(e.target.value)} value={solicitacao} />
                                </div>

                                <div className="col-sm-12 mt-3" style={{ gap: "5px" }}>
                                    <input required multiple={true} type="file" accept={"image/png,image/jpeg,application/pdf"} name={"anexo-solicitacao"} className="d-none" id={`contained-button-file-img-anexo-solicitacao`} onChange={(e) => adicionarAnexos(e.target.files)} ref={inputRef} />

                                    <label htmlFor={`contained-button-file-img-anexo-solicitacao`}>
                                        <span className="add-imagem btn btn-primary btn-bold">
                                            <i className="fas fa-camera" style={{ fontSize: "15px" }}></i>

                                            <p className="mb-0">{"Adicionar anexos"}</p>
                                        </span>
                                    </label>

                                    {anexos.length > 0 ? (
                                        <div className="row">
                                            {anexos.map((anexo, key) => {
                                                return (
                                                    <div key={key} className="col-sm-3">
                                                        <div className="imagemUploaderMargem">
                                                            <a target={"_blank"} rel="noopener noreferrer" href={anexo.id ? anexo.img.url : URL.createObjectURL(anexo.img)}>
                                                                <div className="imagemUploaderBackground" style={{ backgroundImage: `url("${anexo.id ? anexo.img.url : URL.createObjectURL(anexo.img)}")` }}>
                                                                    {!listaFormatoImagens.includes(returnType(anexo)) && <i className="fas fa-file" aria-hidden="true" style={{ fontSize: "180px" }}></i>}
                                                                </div>
                                                            </a>

                                                            <button type="button" className="btn btn-danger btn-bold imagemUploaderBotaoRemover" onClick={() => removerAnexo(key)}>
                                                                <i className="fas fa-times margin-icon" aria-hidden="true"></i>Remover
                                                            </button>
                                                        </div>

                                                        <TextField style={{ marginTop: "0px" }} label="Nome do anexo *" margin="normal" variant="outlined" onChange={(e) => setAnexos(anexos.map((anexo, key2) => (key === key2 ? { ...anexo, nome: e.target.value } : anexo)))} value={anexo.nome} />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ) : (
                                        <Col sm={12} style={{ marginTop: "15px" }}>
                                            <center>
                                                <h5>Sem anexos.</h5>
                                            </center>
                                        </Col>
                                    )}
                                </div>
                            </>
                        )}
                    </div>

                    <BetterDataTable fetchEvent={(e) => getDataTable({ ...e, origem: window.location.href })} crudButtons={false} crudUrl={"/solicitacao"} idRow={`id`} noShow noEdit noDelete noSearch scrollable moreOptions={moreOptions}>
                        <Column style={{ minWidth: "150px" }} field="id" header="Número da solicitação" />
                        <Column style={{ minWidth: "150px" }} field="created_at" header="Data" body={(e) => moment(e.created_at).format("DD/MM/YYYY HH:mm")} />
                        <Column style={{ minWidth: "150px" }} field="admin.adm_nome" header="Solicitante" />
                        <Column style={{ minWidth: "150px" }} field="receptor.adm_nome" header="Usuário" />
                        <Column style={{ minWidth: "150px" }} field="sol_descricao" header="Descrição" />
                        <Column
                            style={{ minWidth: "150px" }}
                            field="arquivos"
                            header="Anexos"
                            body={(e) => (
                                <>
                                    {e.anexos.length > 0 ? (
                                        <div className="d-flex flex-wrap align-items-center" style={{ gap: "8px" }}>
                                            {e.anexos.map((anexo, key) => {
                                                return (
                                                    <a key={key} className="anexo" target={"_blank"} rel="noopener noreferrer" href={anexo.anexo.url}>
                                                        {anexo.sao_nome}
                                                    </a>
                                                );
                                            })}
                                        </div>
                                    ) : (
                                        <>Sem anexos.</>
                                    )}
                                </>
                            )}
                        />
                    </BetterDataTable>
                </Modal.Body>

                <Modal.Footer>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                        <button type="button" className="btn btn-danger btn-bold" onClick={() => setOpenModal(false)}>
                            <i className={`margin-icon ${submitted ? "fas fa-sync fa-spin" : "fa fa-window-close"}`}></i>Cancelar
                        </button>

                        {novaSolicitacao && (
                            <button disabled={submitted} type="button" className="btn btn-success btn-bold pull-right" onClick={() => adicionar()}>
                                <i className={`margin-icon ${submitted ? "fas fa-sync fa-spin" : "fa fa-check-square"}`}></i>Enviar solicitação
                            </button>
                        )}
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}
